export const nonFalse = <T>(v: T): v is T extends false ? never : T => !!v;

export const isMileagePayCode = (payCode: string | undefined): boolean =>
  payCode?.toUpperCase().includes('MILEAGE') ?? false;
